export const uk = {
    'change-success': 'Продукт успешно изменен',
    error: 'Произошла ошибка, повторите попытку'
};
